import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import config from './config';

interface ICommonLineChart {
    labels: string[];
    datasets: unknown[];
}

const LineChart: React.FC<ICommonLineChart> = ({ datasets, labels }: ICommonLineChart) => {
    const chartContainer = useRef(null);
    const [chartInstance, setChartInstance] = useState(null);

    useEffect((): (() => void) => {
        if (chartContainer && chartContainer.current && !chartInstance) {
            const newChartInstance = new Chart(chartContainer.current, config);
            setChartInstance(newChartInstance);
        }

        return (): void => {
            if (chartInstance) {
                chartInstance.destroy();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartContainer]);

    useEffect(() => {
        if (chartInstance) {
            chartInstance.data.datasets = datasets;
            chartInstance.data.labels = labels;
            chartInstance.update();
        }
    }, [chartInstance, datasets, labels]);

    return (
        <div className="relative mb-5 overflow-hidden h-[473px]">
            <canvas ref={chartContainer} />
        </div>
    );
};

export default LineChart;
